/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_SHOW_RESET_PASSWORD_MODAL (state, showModal) {
    state.showResetPasswordModal = showModal
  },
  SET_CURRENT_USER_TO_CHANGE_PASSWORD (state, userHash) {
    state.currentUserToChangePassword = userHash
  },
  SET_USERS (state, users) {
    state.users = users
  },
  REMOVE_RECORD (state, itemId) {
    const userIndex = state.users.findIndex((u) => u.id === itemId)
    state.users.splice(userIndex, 1)
  },
  SET_USER_PROFILE (state, userProfile) {
    state.userProfile = userProfile
  },
  //User Profile Methods
  SET_NAME (state, name) {
    state.userProfile.name = name
  },
  SET_PHOTO (state, photo) {
    state.userProfile.photo = photo
  },
  SET_USERNAME (state, username) {
    state.userProfile.username = username
  },
  setBirthDate (state, birthDate) {
    state.userProfile.birth_date = birthDate
  },
  setMobile (state, mobile) {
    state.userProfile.mobile = mobile
  },
  setWebsite (state, website) {
    state.userProfile.website = website
  },
  setLanguages (state, languages) {
    const new_languages = []

    for (const item of languages) {
      const obj = {id: item.value, name: item.label, hash: item.hash}
      new_languages.push(obj)
    }

    state.userProfile.languages = new_languages
  },
  setAddressOne (state, addressOne) {
    state.userProfile.address_line1 = addressOne
  },
  setAddressTwo (state, addressTwo) {
    state.userProfile.address_line2 = addressTwo
  },
  setPostCode (state, postCode) {
    state.userProfile.post_code = postCode
  },
  setCity (state, city) {
    state.userProfile.city = city
  },
  setState (state, state_data) {
    state.userProfile.state = state_data
  },
  setCountry (state, country) {
    state.userProfile.country = country
  },
  setGenderId (state, genderId) {
    state.userProfile.gender_id = genderId
  },
  setTwitter (state, twitter) {
    state.userProfile.twitter = twitter
  },
  setFacebook (state, facebook) {
    state.userProfile.facebook = facebook
  },
  setInstagram (state, instagram) {
    state.userProfile.instagram = instagram
  },
  setSkype (state, skype) {
    state.userProfile.skype = skype
  },
  setSlack (state, slack) {
    state.userProfile.slack = slack
  },
  setBlog (state, blog) {
    state.userProfile.blog = blog
  },
  SET_CALENDARS_LIST(state, payload) {
    state.userProfile.calendars = payload
  },
  SET_USER_CALENDAR(state, payload) {
    const calendarHash = payload.calendarHash
    const value = payload.value

    state.userProfile.calendars.find(x => x.calendarHash === calendarHash).calendarView = value
  },
  setEmailContact (state, email) {
    state.userProfile.contact_by_email = email
    if (email && !state.userProfile.contacts.includes('email')) {
      state.userProfile.contacts.push('email')
    } else if (!email && state.userProfile.contacts.indexOf('email') >= 0) {
      state.userProfile.contacts.splice(state.userProfile.contacts.indexOf('email'), 1)
    }
  },
  setMessageContact (state, message) {
    state.userProfile.contact_by_message = message
    if (message && !state.userProfile.contacts.includes('message')) {
      state.userProfile.contacts.push('message')
    } else if (!message && state.userProfile.contacts.indexOf('message') >= 0) {
      state.userProfile.contacts.splice(state.userProfile.contacts.indexOf('message'), 1)
    }
  },
  setPhoneContact (state, phone) {
    state.userProfile.contact_by_phone = phone
    if (phone && !state.userProfile.contacts.includes('phone')) {
      state.userProfile.contacts.push('phone')
    } else if (!phone && state.userProfile.contacts.indexOf('phone') >= 0) {
      state.userProfile.contacts.splice(state.userProfile.contacts.indexOf('phone'), 1)
    }
  },
  setAvatar (state, avatar) {
    state.userProfile.photo = avatar
  },

  updateContacts (state) {
    
  },
  setRolesList (state, rolesList) {
    state.rolesList = rolesList
  },

  // User Add Object

  setUserAddRole (state, role) {
    state.userAddObject.role_hash = role
  },
  setUserAddRoleObject (state, roleObject) {
    state.userAddObject.roleObject = roleObject
  },
  setUserAddLanguages (state, languages) {
    state.userAddObject.languages = languages
  },
  setUserAddName (state, name) {
    state.userAddObject.name = name
  },
  setUserAddEmail (state, email) {
    state.userAddObject.email = email
  },
  setUserAddMobile (state, mobile) {
    state.userAddObject.mobile = mobile
  },
  setUserAddUsername (state, username) {
    state.userAddObject.username = username
  },
  setUserAddIsAdmin (state, isAdmin) {
    state.userAddObject.is_admin = isAdmin
  },
  setUserAddExternalUser (state, externalUser) {
    state.userAddObject.external_user = externalUser
  },

  // User Edit Object

  setUserEditName (state, name) {
    state.userEditObject.name = name
  },
  setUserEditEmail (state, email) {
    state.userEditObject.email = email
  },
  setUserEditMobile (state, mobile) {
    state.userEditObject.mobile = mobile
  },
  setUserEditRole (state, role) {
    state.userEditObject.role_hash = role
  },
  setUserEditStatusId (state, statusId) {
    state.userEditObject.status_id = statusId
  },
  setUserEditRoleObject (state, roleObject) {
    state.userEditObject.roleObject = roleObject
  },
  setUserEditStatusId (state, statusId) {
    state.userEditObject.status_id = statusId
  },
  setUserEditIsAdmin (state, isAdmin) {
    state.userEditObject.is_admin = isAdmin
  },
  setUserEditExternalUser (state, externalUser) {
    state.userEditObject.external_user = externalUser
  },
  setUserEditLanguages (state, languages) {
    state.userEditObject.languages = languages
  }
}
